// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-k_gN","advertDetailServiceList__header":"c-k_gO","advertDetailServiceList__list":"c-k_gP"};